// Do not edit.
import { ShaderStore } from "core/Engines/shaderStore";

const name = "skyViewPixelShader";
const shader = `#define RENDER_SKY_VIEW
precision highp float;precision highp sampler2D;
#include<__decl__atmosphereFragment>
uniform sampler2D transmittanceLut;
uniform sampler2D multiScatteringLut;
#include<helperFunctions>
#include<atmosphereFunctions>
varying vec2 uv;void main() {gl_FragColor=renderSkyView(uv,transmittanceLut,multiScatteringLut);}`;
// Sideeffect
if (!ShaderStore.ShadersStore[name]) {
    ShaderStore.ShadersStore[name] = shader;
}
ShaderStore._PendingIncludesLoaders.push(() => Promise.all([
    import("../Shaders/ShadersInclude/atmosphereFragmentDeclaration"),
    import("../Shaders/ShadersInclude/atmosphereUboDeclaration"),
    import("core/Shaders/ShadersInclude/helperFunctions"),
    import("../Shaders/ShadersInclude/atmosphereFunctions")
]));
/** @internal */
export const skyViewPixelShader = { name, shader };
